import { GiHamburgerMenu } from 'react-icons/gi';
import { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import SideBar from './SideBar';
import NavItems from './NavItems';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { User } from 'lucide-react';
import ThemeChanger from '../ThemeChanger';
import api from '../../api';

export default function NavBar({ page = 'landingPage' }) {
  const [openMenuFlag, setOpenMenuFlag] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeMenu = () => {
    setOpenMenuFlag(false);
  };

  // Prevent body scroll when sidebar is open
  useEffect(() => {
    if (openMenuFlag) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [openMenuFlag]);

  const handleLogOut = () => {
    sessionStorage.removeItem("accessToken");
    api.delete('/auth/logout').then((response) => {
      if (response.data.statusCode === 200) {
        setAuth({
          id: null,
          role: null,
        });
      }
    });
  };

  return (
    <>
      {openMenuFlag && (
        <SideBar
          closeMenu={closeMenu}
          page={page}
          handleLogOut={handleLogOut}
        />
      )}

      <div
        className={`w-full ${page === 'landingPage' || page === 'BMC' ? 'sticky' : 'fixed'} top-0 py-2 sm:py-3 px-3 sm:px-5 flex justify-between items-center z-20 bg-base-300 shadow-md`}
      >
        <div className="px-2 py-1 bg-opacity-60 rounded-xl">
          {/* Change Link to simple div for non-landing pages */}
          {page === 'landingPage' ? (
            <Link
              className="transition-all duration-300 cursor-pointer text-xl sm:text-2xl font-extrabold font-poppins bg-gradient-to-r from-indigo-600 to-indigo-300 bg-clip-text text-transparent"
              to="home"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              activeClass="active"
            >
              PathFinder
            </Link>
          ) : (
            <div
              className="text-xl sm:text-2xl font-extrabold font-poppins bg-gradient-to-r from-indigo-600 to-indigo-300 bg-clip-text text-transparent cursor-pointer"
              onClick={() => navigate('/')}
            >
              PathFinder
            </div>
          )}
        </div>

        {windowWidth >= 790 && (
          <>
            <div className="flex justify-center items-center gap-10">
              <NavItems page={page} />
            </div>

            {!auth.id && !auth.role ? (
              <div className="flex items-center gap-2 md:gap-3">
                <ThemeChanger />
                <button
                  className="btn btn-primary btn-sm md:btn-md font-semibold font-opensans"
                  onClick={() => navigate('/login')}
                >
                  Login
                </button>
                <button
                  className="btn btn-secondary btn-sm md:btn-md font-semibold font-opensans"
                  onClick={() => navigate('/signup')}
                >
                  Signup
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2 md:gap-4">
                <ThemeChanger />
                <button
                  className="btn btn-primary btn-sm md:btn-md font-semibold font-opensans"
                  onClick={() => navigate('/dashboard')}
                >
                  <User className="w-5 h-5" />
                </button>
                <button
                  className="btn btn-secondary btn-sm md:btn-md font-semibold font-opensans"
                  onClick={handleLogOut}
                >
                  Signout
                </button>
              </div>
            )}
          </>
        )}

        {windowWidth < 790 && !openMenuFlag && (
          <div className="flex justify-center items-center gap-5">
            <ThemeChanger />
            <button
              className="p-2 hover:bg-base-200 rounded-full transition-colors duration-200"
              onClick={() => setOpenMenuFlag(true)}
              aria-label="Open menu"
            >
              <GiHamburgerMenu className="w-6 h-6" />
            </button>
          </div>
        )}
      </div>
    </>
  );
}
